import React, { FC } from "react";
import clsx from "clsx";

import Preloader from "~/components/Preloader";

import s from "./PanelWrapper.less";

interface IProps {
  label?: string;
  width?: number;
  height?: number;
  backgroundColor?: string;
  onClickLink?;
  loading?: boolean;
  clickable?: boolean;
  drainsDown?: boolean;
  isFixed?: boolean;
  customClassName?: string;
}

const PanelWrapper: FC<IProps> = ({
  label = "",
  customClassName = "",
  width = 100,
  height = 70,
  backgroundColor,
  loading = false,
  clickable = false,
  drainsDown = false,
  isFixed = false,
  onClickLink,
  children,
}) => {
  return (
    <div
      onClick={onClickLink}
      className={clsx(s.s_panel_wrap, customClassName, {
        [s.s_clickable]: clickable,
        [s.fixed]: isFixed,
        [s.s_drains_down]: drainsDown,
      })}
      style={{ width, height, backgroundColor }}
    >
      {!(loading && height <= 70) && label && (
        <label className={s.title}>{label}</label>
      )}
      {loading ? <Preloader noText={width < 150} /> : children}
    </div>
  );
};

export default PanelWrapper;
